import { render, staticRenderFns } from "./WEmployeeModal.yaml?vue&type=template&id=685ad1e8&component"
import script from "./WEmployeeModal.yaml?vue&type=script&lang=ts&component"
export * from "./WEmployeeModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports